import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/3E6PtasSxGeyg8mMNaDpPL/optimized_1.webp', 'https://cdn.magicpatterns.com/uploads/dV3kQnLV5CK1v3R8ev4Zj9/optimized_2.webp', 'https://cdn.magicpatterns.com/uploads/66o2uSPcAzvGDkgRrH1mrM/optimized_3.webp', 'https://cdn.magicpatterns.com/uploads/c9wjPXLrWbjZSEqXeo7XjL/optimized_4.webp', 'https://cdn.magicpatterns.com/uploads/a9GvhS9LNUAsfCAJ2RbpMt/optimized_5.webp'];
export function ContentCarousel() {
  return <section className="py-8 md:py-20 overflow-hidden" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-5 md:mb-10 text-center" data-id="element-17">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-text-main" data-id="element-18">
          Algo de lo que contiene nuestro pack
        </motion.h2>
      </div>

      <div className="relative" data-id="element-19">
        <motion.div className="flex gap-6 px-4 md:px-10 cursor-grab active:cursor-grabbing" drag="x" dragConstraints={{
        right: 0,
        left: -1200
      }} initial={{
        x: 0
      }} data-id="element-20">
          {images.map((src, index) => <motion.div key={index} className="min-w-[280px] md:min-w-[400px] aspect-[3/4] rounded-2xl overflow-hidden border border-accent-cyan/20 bg-primary-card shadow-2xl" whileHover={{
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} data-id="element-21">
              <img src={src} alt={`Contenido del pack ${index + 1}`} className="w-full h-full object-cover" draggable={false} data-id="element-22" />
            </motion.div>)}
        </motion.div>

        {/* Gradient overlays for fade effect */}
        <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-primary to-transparent pointer-events-none hidden md:block" data-id="element-23"></div>
        <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-primary to-transparent pointer-events-none hidden md:block" data-id="element-24"></div>
      </div>

      <div className="mt-4 flex justify-center gap-2 md:hidden" data-id="element-25">
        <p className="text-text-muted text-sm italic" data-id="element-26">Desliza para ver más →</p>
      </div>
    </section>;
}